import { useState,useEffect } from "react"
import { useParams,useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import ApiService from "../../services/apiService"
import Update from "../table/Update"
import { method } from "lodash"
import { toast } from "react-toastify"
import { error } from "console"
const UpdatePumpingStation = () =>{
     
    const navigate = useNavigate();
    const{Id} = useParams();
    const[data,setData] = useState<any>()
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
      
    const initialData ={
         
        Name: data?.name,
        Type:data?.type,
        No_Of_Pumps : data?.no_Of_Pumps,
        IncludeInDashboard: data?.includeInDashboard 
        
    }
      
    useEffect(()=>{
         const fetchPumpingStation  = async() =>{
               
            try{
                 const response = await ApiService.axiosApi(`/pumpingstation/${Id}`,{
                     method:'GET'
                 });

                 if(response.success){
                     setData(response.data)
                 }else{
                     toast.error("Failed to fecth Pumping Station")
                 }

            }catch(e :any){
                 toast.error(e.message || "Failed to fect pumping station" )
            }
         }
         if(Id) fetchPumpingStation();
    },[Id, navigate, setValue])


    const onSubmit = async (data:any) =>{
          try{
             const UpdateData ={
                Name: data.Name,
                Type:data.Type,
                No_Of_Pumps : data.No_Of_Pumps,
                IncludeInDashboard: data.IncludeInDashboard === 'true' ? true : false
             }

             const response = await ApiService.axiosApi(`/pumpingstation/${Id}`,{
                 method:'PUT',
                 data:UpdateData
             });

             if(response.success){
                 toast.success("Pumping Station Update Succesfully")
                 navigate(-1)
             }else{
                 toast.error(response.data.message || "Failed To Update Pumping Station")
             }
          }catch(e:any){
            toast.error(e.message || "Failed To Update Pumping Station")
          }
    }
           
    return (
         <>
           <Update
              title ={'Update Pumping Station'}
              parentTitle={'Pumping Station'} 

              fields ={[
                {
                     name : 'Name',
                     label: 'Name',
                     type: 'text'
                },
                {
                     name:'Type',
                    label:'Type',
                    type:'text'
                },
                {
                   name:'No_Of_Pumps',
                   label:'Number Of Pumps',
                   type:'text'  
                },
                {
                    name:'IncludeInDashboard',
                    label:'Include In Dashboard',
                    type:'text'
                }
              ]}

              onSubmit = {onSubmit}
              initialData = {initialData}
           />
         </>
    )
}

export default UpdatePumpingStation;